var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon } from '@marketing-icons';
import { clsx } from 'clsx';
import { useRef, useState } from 'react';
import { Link } from 'react-router';
function Snackbar(_a) {
    var _b;
    var text = _a.text, url = _a.url, onClose = _a.onClose, _c = _a.theme, theme = _c === void 0 ? 'light' : _c;
    var _d = useState(true), isVisible = _d[0], setIsVisible = _d[1];
    var snackbarRef = useRef(null);
    var handleClose = function () {
        setIsVisible(false);
        onClose && onClose();
    };
    var themeColors = theme === 'light' ? 'bg-deco-pink text-shoe' : 'bg-shoe text-bone';
    return (_jsxs("div", __assign({ ref: snackbarRef, "aria-hidden": !isVisible, style: {
            marginTop: isVisible ? 0 : "-".concat((_b = snackbarRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight, "px"),
        }, className: clsx('top-0 left-0 flex p-2xs-gutter justify-between items-center w-full z-50', themeColors, 'transition-[margin-top] duration-300 ease-in-out overflow-hidden') }, { children: [_jsx("button", __assign({ type: "button", className: "justify-self-start", "aria-label": "Close", onClick: handleClose }, { children: _jsx(CloseIcon, { className: clsx(theme === 'light' ? 'text-icon-dark' : 'text-icon-white') }) })), _jsx(Link, __assign({ to: url, viewTransition: true, className: "text-sm-med-m md:text-sm-med-d" }, { children: text })), _jsx("div", { className: "w-[24px] h-[24px] justify-self-end shrink-0" })] })));
}
export default Snackbar;
